import { render, staticRenderFns } from "./ExpandedHeader.vue?vue&type=template&id=7e1c88a0&scoped=true&"
import script from "./ExpandedHeader.vue?vue&type=script&lang=ts&"
export * from "./ExpandedHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedHeader.vue?vue&type=style&index=0&id=7e1c88a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c88a0",
  null
  
)

export default component.exports